module.exports = __webpack_public_path__ + "img/perfectmoney_static.f8fe31f7.svg";